import { CreateSubscriptionConnectorApollo } from '@front-activerse/common-components';
import BuyIndexContainer from './BuyIndexContainer';

const BuyIndexPage = () => {
  return (
    <CreateSubscriptionConnectorApollo>
      {({ buy }) => <BuyIndexContainer {...{ buy }} />}
    </CreateSubscriptionConnectorApollo>
  );
};

export default BuyIndexPage;
